import { WasteAmount } from 'redux/ducks/settings';
import { isNumeric } from 'utils/math';

// A foodwaste target may only be saved with both a positive amount and a period.
// The API rejects a WasteAmount that carries an amount without a period (PROD-14967),
// so both must be present before the target counts as complete.
const hasAmount = (target: WasteAmount): boolean => isNumeric(target.amount) && target.amount > 0;

export const isTargetComplete = (target: WasteAmount): boolean =>
  hasAmount(target) && Boolean(target.period);

// True when the user has entered an amount but not yet chosen a period, which is the
// state that must block saving and be surfaced on the period field.
export const isPeriodMissing = (target: WasteAmount): boolean =>
  hasAmount(target) && !target.period;
